if (!customElements.get("variant-picker")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.section = this.closest(".js-product"), this.productForm = this.section
        .querySelector(".js-product-form-main"), this.optionSelectors = this.querySelectorAll(
          ".option-selector"), this.data = this.getProductData(), this.variant = this
        .getSelectedVariant(), this.updateAvailability(), this.updateAddToCartButton(), this
        .addEventListener("change", this.handleVariantChange.bind(this))
    }
    handleVariantChange(e) {
      this.variant = null, this.variant = this.getSelectedVariant(), this.variant && (this
          .updateMedia(), this.updateUrl(e), this.updateVariantInput()), this
        .updateAddToCartButton(), this.updateAvailability(), this.updatePrice(), this
        .updateWeight(), this.updateBarcode(), this.updateBackorderText(), this
        .updatePickupAvailability(), this.updateSku(), t.updateLabelText(e), this.dispatchEvent(
          new CustomEvent("on:variant:change", {
            bubbles: !0,
            detail: {
              form: this.productForm,
              variant: this.variant,
              product: this.data.product
            }
          }))
    }
    updateAddToCartButton() {
      if (this.productForm = this.section.querySelector(".js-product-form-main"), !this
        .productForm) return;
      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      let t = this.variant && this.variant.available,
        e = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      this.addBtn.disabled = !t, this.addBtn.textContent = t ? this.addBtn.dataset.addToCartText :
        e
    }
    static updateOptionAvailability(t, e, i) {
      let a = t,
        r = e ? theme.strings.noStock : theme.strings.noVariant;
      if (a.classList.toggle("is-unavailable", !i), a.classList.toggle("is-nonexistent", !e), t
        .classList.contains("custom-select__option")) {
        let s = a.querySelector("em");
        s && (s.hidden = i), i || (s ? s.textContent = r : a.innerHTML =
          `${a.innerHTML} <em class="pointer-events-none">${r}</em>`)
      } else i ? a.nextElementSibling.removeAttribute("title") : a.nextElementSibling.title = r
    }
    updateAvailability() {
      if ("false" === this.dataset.showAvailability) return;
      let {
        availabilityMethod: e
      } = this.dataset, i = this.variant, a = this.getSelectedOptions();
      this.variant || (i = {
        options: a
      }), "selection" === e ? (this.querySelectorAll(".js-option").forEach(e => {
        t.updateOptionAvailability(e, !1, !1)
      }), this.optionSelectors.forEach((e, a) => {
        this.data.product.variants.forEach(r => {
          let s = 0;
          if (r.options.forEach((t, e) => {
              t === i.options[e] && e !== a && (s += 1)
            }), s === i.options.length - 1) {
            let n = e.querySelectorAll(".js-option"),
              o = Array.from(n).find(t => "dropdown" === e.dataset.selectorType ? t
                .dataset.value === r.options[a] : t.value === r.options[a]);
            o && t.updateOptionAvailability(o, !0, r.available)
          }
        })
      })) : this.optionSelectors.forEach((e, i) => {
        let r = e.querySelectorAll('.js-option:not([data-value=""])');
        r.forEach(r => {
          let s = "dropdown" === e.dataset.selectorType ? r.dataset.value : r.value,
            n = !1,
            o = !1;
          this.data.product.variants.forEach(t => {
            let e = 0;
            for (let r = 0; r < i; r += 1)(t.options[r] === a[r] || null === a[r]) &&
              (e += 1);
            t.options[i] === s && e === i && (n = !0, t.available && (o = !0))
          }), t.updateOptionAvailability(r, n, o)
        })
      })
    }
    updateBackorderText() {
      if (this.backorder = this.backorder || this.section.querySelector(".backorder"), !this
        .backorder) return;
      let t = !0;
      if (this.variant && this.variant.available) {
        let {
          inventory: e
        } = this.data.formatted[this.variant.id];
        if (this.variant.inventory_management && "none" === e) {
          let i = this.backorder.querySelector(".backorder__product"),
            a = this.section.querySelector(".product-title"),
            r = this.variant.title.includes("Default") ? "" : ` - ${this.variant.title}`;
          i.textContent = `${a.textContent}${r}`, t = !1
        }
      }
      this.backorder.hidden = t
    }
    static updateLabelText(t) {
      let e = t.target.closest(".option-selector");
      if ("dropdown" === e.dataset.selectorType) return;
      let i = e.querySelector(".js-color-text");
      i && (i.textContent = t.target.nextElementSibling.querySelector(".js-value").textContent)
    }
    updateMedia() {
      if (this.variant.featured_media) {
        if (this.section.matches("quick-add-drawer")) this.section.updateMedia(this.variant
          .featured_media.id);
        else {
          if (this.mediaGallery = this.mediaGallery || this.section.querySelector(
            "media-gallery"), !this.mediaGallery) return;
          let t = this.mediaGallery.querySelector(
            `[data-media-id="${this.variant.featured_media.id}"]`);
          this.mediaGallery.setActiveMedia(t, !0, !0)
        }
      }
    }
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector(
        "pickup-availability"), this.pickUpAvailability && (this.variant && this.variant
        .available ? this.pickUpAvailability.getAvailability(this.variant.id) : (this
          .pickUpAvailability.removeAttribute("available"), this.pickUpAvailability.innerHTML =
          ""))
    }
    updatePrice() {
      if (this.price = this.price || this.section.querySelector(".product-info__price > .price"),
        this.price) {
        if (this.variant) {
          let t = this.price.querySelector(".price__current"),
            e = this.price.querySelector(".price__was"),
            i = this.price.querySelector(".unit-price");
          if (t.innerHTML = this.data.formatted[this.variant.id].price, e && (e.innerHTML = this
              .data.formatted[this.variant.id].compareAtPrice || ""), this.variant
            .unit_price_measurement) {
            let a = this.price.querySelector(".unit-price__price"),
              r = this.price.querySelector(".unit-price__unit"),
              s = this.variant.unit_price_measurement.reference_value,
              n = this.variant.unit_price_measurement.reference_unit;
            a.innerHTML = this.data.formatted[this.variant.id].unitPrice, r.textContent = 1 ===
              s ? n : `${s} ${n}`
          }
          i.hidden = !this.variant.unit_price_measurement, this.price.classList.toggle(
              "price--on-sale", this.variant.compare_at_price > this.variant.price), this.price
            .classList.toggle("price--sold-out", !this.variant.available)
        }
        this.price.querySelector(".price__default").hidden = !this.variant, this.price
          .querySelector(".price__no-variant").hidden = this.variant
      }
    }
    updateWeight() {
      if (this.weights = this.weights || this.section.querySelectorAll(".product-info__weight"),
        0 === this.weights.length) return;
      let t = this.variant && this.variant.weight > 0;
      this.weights.forEach(e => {
        e.textContent = t ? this.data.formatted[this.variant.id].weight : "", e.hidden = !t
      })
    }
    updateBarcode() {
      if (this.barcodes = this.barcodes || this.section.querySelectorAll(
          ".product-info__barcode-value"), 0 === this.barcodes.length) return;
      let t = this.variant && this.variant.barcode;
      this.barcodes.forEach(e => {
        e.textContent = t ? this.variant.barcode : "", e.parentNode.hidden = !t
      })
    }
    updateSku() {
      if (this.sku = this.sku || this.section.querySelector(".product-sku__value"), !this.sku)
        return;
      let t = this.variant && this.variant.sku;
      this.sku.textContent = t ? this.variant.sku : "", this.sku.parentNode.hidden = !t
    }
    updateUrl(t) {
      t && "change" === t.type && "false" !== this.dataset.updateUrl && window.history
        .replaceState({}, "", `${this.dataset.url}?variant=${this.variant.id}`)
    }
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll(
        ".js-product-form-main, .js-instalments-form"), this.forms.forEach(t => {
        let e = t.querySelector('input[name="id"]');
        e.value = this.variant.id, e.dispatchEvent(new Event("change", {
          bubbles: !0
        }))
      })
    }
    getSelectedOptions() {
      let t = [];
      return this.optionSelectors.forEach(e => {
        "dropdown" === e.dataset.selectorType ? t.push(e.querySelector(".custom-select__btn")
          .textContent.trim()) : t.push(e.querySelector("input:checked").value)
      }), t
    }
    getProductData() {
      let t = this.querySelector('[type="application/json"]');
      return JSON.parse(t.textContent)
    }
    getSelectedVariant() {
      let t = this.getSelectedOptions();
      return this.data.product.variants.find(e => e.options.every((e, i) => e === t[i]))
    }
  }
  customElements.define("variant-picker", t)
}
